<template>
	<div class="shares-box">
		<div class="shares">
			<a href="javascript:;" id="wechat">
				<span class="iconfont">&#xe933;</span>
				<img src="../../assets/wechatcode.jpg" alt="">
			</a>
			<a target="_blank" id="QQ" href="http://wpa.qq.com/msgrd?v=3&uin=2352221613&site=qq&menu=yes">
				<span class="iconfont">&#xe6af;</span>
				<b>2352221613</b>
			</a>
			<a href="javascript:;" id="phone">
				<span class="iconfont">&#xe600;</span>
				<b>0757-86689109</b>
			</a>
			<a href="javascript:;" id="gotop" v-if="btnFlag" @click="backTop">
				<i class="el-icon-arrow-up"></i>
			</a>
		</div>
    <div class="shares-nav">
      <a target="_blank" href="javascript:;" @click="qqchat()">
      	<span class="iconfont">&#xe6af;</span>
      </a>
      <a href="tel:0757-86689109">
      	<span class="iconfont">&#xe600;</span>
      </a>
      <a href="javascript:;" @click="openT()">
      	<span class="iconfont">&#xe667;</span>
      </a>
    </div>
		<el-dialog title="" :visible.sync="centerDialogVisible" width="80%" center>
			<el-form ref="form" :rules="rules" :model="form" label-width="80px">
				<el-form-item :label="$t('contact.online.name')" prop="name" style="display: inline-block;">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item :label="$t('contact.online.phone')" prop="phone" style="display: inline-block;">
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item :label="$t('contact.online.Email')" prop="email" style="display: inline-block;">
					<el-input v-model="form.email"></el-input>
				</el-form-item>
				<el-form-item class="textarea" :label="$t('contact.online.message')" prop="desc" style="margin: 0 auto;width: 858px;margin-bottom: 22px;">
					<el-input type="textarea" v-model="form.desc"></el-input>
				</el-form-item>
				<el-form-item class="submit">
					<el-button type="primary" @click="onSubmit('form')">{{$t('contact.online.submit')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'shares',
	data() {
		return {
      btnFlag : true,
			centerDialogVisible : false,
			form: {
				name: '',
				phone: '',
				email: '',
				desc: ''
			},
			rules: {
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				phone: [
					{ required: true, message: '请输入电话', trigger: 'blur' }
				],
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' }
				],
				desc: [
					{ required: true, message: '请输入内容', trigger: 'blur' }
				],
			}
		};
	},
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
        var that = this
        var timer = setInterval(function() {
          var ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      var that = this
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
		qqchat(){
			var ua = window.navigator.userAgent.toLowerCase();
			if(ua.match(/MicroMessenger/i) == 'micromessenger'){
				window.open('http://wpa.qq.com/msgrd?v=3&uin=2352221613&site=qq&menu=yes');
			}else{
				window.open('mqqwpa://im/chat?chat_type=wpa&uin=2352221613&version=1&src_type=web&web_src=oicqzone.com');
			}
		},
		openT(){
			this.centerDialogVisible = true
			
		},
		
		onSubmit(e) {
			var that = this;
			var data = that.form;
			this.$refs[e].validate(function(valid){
				if(valid){
					console.log(that.form);
					that.axios({
						method: 'post',
						url:'http://ad.dinovor.com/message/websiteMessages',
						contentType:'application/json;charset=utf-8',
						dataType:'json',
						data:{
							"content": data.desc,
							"email": data.email,
							"mobile": data.phone,
							"name": data.name
						}
					}).then(function(res) {
						if(res.data.rtnCode == 200){
							alert('提交成功')
						}else{
							alert(res.data.msg);
						}
					})
				}else{
					return false;
				}
			});
		}
  }
}
</script>

<style>
.shares{
  position: fixed;
  right: 7px;
	top: 65%;
  z-index: 97;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
.shares a{
  width: 46px;
  height: 46px;
  border: 1px solid #cfcfcf;
  background-color: #fff;
	text-decoration: none;
  transition: all .3s ease;
	overflow: hidden;
	position: relative;
}
.shares a span{
	line-height: 46px;
	color: #999;
	font-size: 18px;
	width: 46px;
	display: block;
	text-align: center;
	transition: all .3s ease;
}
.shares a b{
	line-height: 46px;
	color: #fff;
	font-size: 18px;
	font-weight: normal;
	width: 135px;
	display: block;
	position: absolute;
	top: 0;
	left: 46px;
}
.shares a i{
  line-height: 46px;
	width: 46px;
  color: #999;
	font-size: 24px;
}
.shares a img{
	width: 180px;
	position: absolute;
	top: 50%;
	left: -172px;
	transform: translateY(-50%);
	padding: 10px;
	background-color: #e0e0e0;
	box-sizing: border-box;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease;
}
.shares #wechat::after{
	content: "";
	position: absolute;
	border: 8px solid rgba(0,0,0,0);
	top: 50%;
	left: 10px;
	transform: translateY(-50%);
	border-left-color: #e0e0e0;
	visibility: hidden;
	opacity: 0;
	transition: all .3s ease;
}
.shares a:hover{
  background-color: #00a1d6;
}
.shares a:hover span{
  color: #fff;
}
.shares a:hover i{
  color: #fff;
}
.shares #phone:hover,.shares #QQ:hover{
	width: 200px;
}
.shares #wechat{
	overflow: inherit;
}
.shares #wechat:hover::after{
	left: -10px;
	opacity: 1;
	visibility: visible;
}
.shares #wechat:hover img{
	left: -192px;
	opacity: 1;
	visibility: visible;
}
.shares-nav{
  position: fixed;
  width: 80%;
  height: 50px;
	border-radius: 25px;
  box-sizing: border-box;
  background-color: rgba(0,0,0,.6);
  left: 50%;
  bottom: 30px;
	transform: translateX(-50%);
  z-index: 97;
  display: none;
  justify-content: space-around;
}
.shares-nav a{
  text-decoration: none;
}
.shares-nav a span{
	line-height: 50px;
	color: #fff;
	font-size: 18px;
	width: 60px;
	display: block;
	text-align: center;
}

.shares-box .el-form-item__label{
  color: #aeaeae;
}
.shares-box .el-textarea__inner{
	min-height: 100px !important;
}
.shares-box .el-button--primary{
  background: #333;
  border-color: #333;
}
.shares-box .el-form-item__label{
	width: 40px !important;
}
.shares-box .textarea{
	display: inline-block;
	width: 100% !important;
}
.shares-box .submit .el-form-item__content{
	margin-left: 0 !important;
	text-align: center;
}
@media (max-width: 992px){
  .shares{
    top: 80%;
  }
  .shares #phone,.shares #QQ,.shares #wechat{
    display: none;
  }
  .shares-nav{
    display: flex;
  }
	.shares-box .el-form-item__label{
		width: 80px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/shares.vue